export default function Loading({ message }: { message?: string }) {
  const loaders = ["squares", "circle1", "circle2", "atom"];
  const loaderClass = loaders[Math.floor(Math.random() * loaders.length)];
  return (
    <div className="loading">
      {message && <div>{message}</div>}
      <div className={`loader-${loaderClass}`} />
    </div>
  );
}
